import React from "react";
import { ShortcutKeys } from "../../shortcuts/Kbd";
import { H, Note, P, Term } from "./elements";

export const DustArticle: React.FC = () => (
  <>
    <P>
      Woodworking creates chips and sawdust, which pile up on the floor and slow
      down everything you do: work at a dust-covered machine takes longer, and
      walking through deep dust costs extra steps. Keeping a clean shop keeps
      work moving at full speed.
    </P>

    <H>The Broom</H>
    <P>
      Pick the broom up with <ShortcutKeys shortcut="pick-up" /> standing beside
      it. With it in hand, hold <ShortcutKeys shortcut="operate-machine" /> and
      walk: the broom sweeps the dust ahead of you into its <Term>dustpan</Term>
      . The mouse steers the head, so you can work a patch to either side
      without turning. Sweeping beside a machine also pulls dust out from under
      it, slowly.
    </P>
    <P>
      When the dustpan fills up, stand at the garbage can and hold{" "}
      <ShortcutKeys shortcut="operate-machine" /> to pour it out. The broom
      takes both hands; set it down with <ShortcutKeys shortcut="put-down" />{" "}
      before picking anything else up.
    </P>

    <H>The Shop Vac</H>
    <P>
      Grab the vac with <ShortcutKeys shortcut="pick-up" /> and park it with{" "}
      <ShortcutKeys shortcut="put-down" />; grabbing it means holding its hose,
      which takes your hands like the broom does. Dragging it steadily cleans
      whatever you walk over, and holding{" "}
      <ShortcutKeys shortcut="operate-machine" /> runs the nozzle over the floor
      ahead of you, machines' undersides included.
    </P>
    <P>
      Dust collects in the canister, which holds far more than the broom's
      dustpan. When it fills, the suction stops. Wheel it to the garbage can and
      hold <ShortcutKeys shortcut="operate-machine" /> to empty it.
    </P>

    <Note>
      The planer makes more dust than everything else combined — plan on
      sweeping after every milling session.
    </Note>
  </>
);
